(function () {
    angular.module('emarket.commons').constant('THEME', {
        primary: {
            name: 'emarket',
            values: {
                '50': '#e8f9ff',
                '100': '#9ce6ff',
                '200': '#64d8ff',
                '300': '#1cc6ff',
                '400': '#00bdfd',
                '500': '#00a6de',
                '600': '#008fbf',
                '700': '#0078a1',
                '800': '#006182',
                '900': '#004a64',
                'A100': '#e8f9ff',
                'A200': '#9ce6ff',
                'A400': '#00bdfd',
                'A700': '#0078a1',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 300 400 A100 A200 A400'
            }
        },
        accent: {
            name: 'emarketAccent',
            values: {
                '50': '#fff5f0',
                '100': '#ffc4a4',
                '200': '#ff9f6c',
                '300': '#ff7124',
                '400': '#ff5d06',
                '500': '#e65100',
                '600': '#c74600',
                '700': '#a93b00',
                '800': '#8a3100',
                '900': '#6c2600',
                'A100': '#fff5f0',
                'A200': '#ffc4a4',
                'A400': '#ff5d06',
                'A700': '#a93b00',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 300 400 A100 A200 A400'
            }
        },
        themeColor: '#00a6de'
    });
}());
